import {KeyValue} from "./keyValue";
import {TagType} from "../../components/atoms/tag/tag";

/**
 * This represents a selectable item in the tag option menu.
 */
export class TagKeyValue extends KeyValue {
  /**
   * The type of tag to show for this value
   */
  tagType: TagType;

  /**
   * Is this value disabled in the dropdown
   */
  isDisabled: boolean;

  constructor(
    value: string,
    label: string,
    tagType: TagType,
    disabled: boolean
  ) {
    super(value, label);
    this.tagType = tagType;
    this.isDisabled = disabled;
  }
}
